import 'ui-theme/widgets/raa/js/raa';

(function () {
    $(document).ready(function () {
        let ele = $('.login-form .input-group .iconable__input').next('.icon-mail');
        if (ele.length > 0) {
            ele.remove();
        }
    });
})();
